import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { contractTenantsSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = (contractUUID: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${contractUUID}/tenants`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/tenants`,
      contractTenantsSchema
    ),
})

export const useAPIGetContractTenants = (contractUUID: string) =>
  useQuery(params(contractUUID))

export const useAPIGetContractTenantsSuspense = (contractUUID: string) =>
  useSuspenseQuery(params(contractUUID))
